import { defineComponent as _defineComponent } from 'vue'
import { computed, nextTick, Ref, ref, toRef } from 'vue'
import AutoCompleteShell from '@/components/vision/next/inputs/AutoCompleteShell.vue'
import PickerListItem from '@/components/vision/next/picker-list/PickerListItem.vue'
import PickerListVirtualized from '@/components/vision/next/picker-list/PickerListVirtualized.vue'
import {
  HeadlessAutoCompleteValueType,
  ValueResolver,
} from '@/components/vision/next/inputs/useAutoComplete'
import VsText from '@/components/vision/VsText.vue'
import { useFormField } from '@/components/vision/next/forms/useFormAdapter'
import {
  SearchOptions,
  useNewAutocomplete,
} from '@/components/vision/next/inputs/UseNewAutocomplete'
import { PickerItemType } from '@/components/vision/next/picker-list/models'


export default /*#__PURE__*/_defineComponent({
  __name: 'NewAutocomplete',
  props: {
    value: { default: null },
    hint: { default: null },
    isDisabled: { type: Boolean, default: false },
    label: null,
    useSearchItems: null,
    valueResolver: null,
    allowCustomValue: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    customValidationRules: null
  },
  emits: ["autofill", "selected"],
  setup(__props: any, { expose, emit }: { emit: ({
  (e: 'autofill', field: string, value: string): void
  (e: 'selected', id: any): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: string | null, hint: string | null, isDisabled: boolean, label: string, useSearchItems: (options: Ref<SearchOptions>) => {
      items: Ref<Readonly<PickerItemType[]>>
      hasNextPage: Ref<boolean>
      fetchNextPage: (options?: any) => any
      isFetching: Ref<boolean>
      isFetched: Ref<boolean>
      isInitialLoading: Ref<boolean>
    }, valueResolver: ValueResolver, allowCustomValue: boolean, required: boolean, customValidationRules?: ((value: any) => string | undefined)[] }



const valueAsRef = toRef(props, 'value')
const requiredAsRef = toRef(props, 'required')

const handleCustomInputClick = () => {
  onValueChanged({
    id: search.value,
    title: search.value,
  })
  autocomplete.value?.close()
}
const isSelected = (item: HeadlessAutoCompleteValueType) => {
  return item.id === valueAsRef.value
}
const autocomplete = ref()
const virtualizedList = ref()
const onNavigate = () => {
  autocomplete.value?.input?.focus()
}
const scrollToPosition = (pos: number) => {
  virtualizedList?.value?.scrollToPosition(pos)
}

const onValueChanged = (incoming?: HeadlessAutoCompleteValueType) => {
  if (incoming && incoming.id === valueAsRef.value) {
    return
  }
  emit('selected', incoming?.id)
  if (incoming) {
    autocomplete.value?.close(false)
  }
}

const {
  items,
  updateSearch,
  selectItem,
  clear,
  clearSearch,
  search,
  continueFetching,
  noResultsMessage,
} = useNewAutocomplete({
  onNavigate,
  scrollToPosition,
  valueResolver: props.valueResolver,
  onValueChanged,
  value: valueAsRef,
  useSearchItems: props.useSearchItems,
})

const { allErrorMessages: remoteErrors, runValidation } = useFormField({
  value: valueAsRef,
  required: requiredAsRef.value,
  localRules: props.customValidationRules,
})

const customValueButtonLabel = computed(() => `New "${search.value}"`)
const isSearchTextInItems = computed(() =>
  items.value.some((item) => item.title === search.value)
)

const onClose = () => {
  nextTick().then(() => runValidation())
}

const onCloseExpand = (enableEmitCustomSearchValue = true) => {
  if (props.allowCustomValue && search.value && enableEmitCustomSearchValue) {
    emit('selected', search.value)
    autocomplete.value?.setModified(false)
    nextTick().then(() => runValidation())
  } else {
    clearSearch()
  }
}

expose({
  clear,
  search,
})

return { __sfc: true,props, valueAsRef, requiredAsRef, emit, handleCustomInputClick, isSelected, autocomplete, virtualizedList, onNavigate, scrollToPosition, onValueChanged, items, updateSearch, selectItem, clear, clearSearch, search, continueFetching, noResultsMessage, remoteErrors, runValidation, customValueButtonLabel, isSearchTextInItems, onClose, onCloseExpand, AutoCompleteShell, PickerListItem, PickerListVirtualized, VsText }
}

})